const oboardingPt = {
  errors: {
    204: 'Este usuário já existe. A operação foi cancelada',
    401: 'Seu convite expirou. Por favor, contate o administrador do 4bee Work+ para o envio de um novo',
    generic: 'Não foi possível completar esta ação',
  },
};

export default oboardingPt;
